import { render } from "./SolidBlob.vue?vue&type=template&id=27b2d787&scoped=true"
import script from "./SolidBlob.vue?vue&type=script&lang=js"
export * from "./SolidBlob.vue?vue&type=script&lang=js"

import "./SolidBlob.vue?vue&type=style&index=0&id=27b2d787&scoped=true&lang=scss"
import "./SolidBlob.vue?vue&type=style&index=1&id=27b2d787&lang=scss"

import exportComponent from "/srv/sites/eservice.talronbatt.co.il/api/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27b2d787"]])

export default __exports__